import { z } from 'zod'
import { oc } from '@orpc/contract'

export const appendTranscriptResponseSchema = z.object({
  sessionId: z.string(),
  chunkCount: z.number(),
})
export type AppendTranscriptResponse = z.infer<typeof appendTranscriptResponseSchema>

export const scribeAppendTranscript = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/transcript' })
  .input(
    z.object({
      encounterId: z.string(),
      text: z.string().min(1),
      sessionId: z.string().min(1),
      speaker: z.string().optional(),
      timestamp: z.string().optional(),
    }),
  )
  .output(appendTranscriptResponseSchema)
